<template>
  <div class="layer claimSearch">
    <div class="claim" :style="{height:height}">
      <div class="claim-top">
        <el-tag type="info">合并认领列表</el-tag>
      </div>
      <div class="claim-table">
        <el-table :data="tableData" stripe border header-align="center" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="姓名">
                  <span>{{ props.row.name }}</span>
                </el-form-item>
                <el-form-item label="机构">
                  <span>{{ props.row.organization }}</span>
                </el-form-item>
                <el-form-item label="学科">
                  <span>{{ props.row.subject }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" min-width="60px" label="姓名"></el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="organization"
            min-width="120px"
            label="学校"
          ></el-table-column>
          <el-table-column align="center" width="60px" label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.row,scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button class="merge" type="primary" @click="merge" v-if="tableData.length">合并</el-button>
    </div>
    <div class="experts" v-loading="loading" ref="expHeader">
      <div class="exp-top">
        <h4 style="display: flex;align-items: center;">已经为您检索到{{total}}条</h4>
        <div class="exp-search">
          <span>机构检索：</span>
          <el-input style="width:50%;" placeholder="请输入机构" v-model="inputOrg" clearable></el-input>
          <el-button style="margin-left:2%;" type="primary" @click="search">搜索</el-button>
        </div>
      </div>
      <div
        class="exp-box"
        :style="{width:expWidth}"
        v-for="(item,index) in expertsData"
        :key="index"
      >
        <div class="exp-int">
          <router-link
            :to="{path:'/Detail',query: /^\d+$/.test(item.kId)? {kId:item.kId } :{name:item.name,institute:item.organization}}"
          >
            <el-image
              class="exp-header"
              :src="item.avatarUrl?'/old/public'+item.avatarUrl:'http://expert.ckcest.cn/autoload/images/avatar.png'"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot">
                <img
                  width="80px"
                  height="100px"
                  src="http://expert.ckcest.cn/autoload/images/avatar.png"
                />
              </div>
              <div slot="error" class="image-slot">
                <img
                  width="80px"
                  height="100px"
                  src="http://expert.ckcest.cn/autoload/images/avatar.png"
                />
              </div>
            </el-image>
          </router-link>
          <div class="exp-textint">
            <router-link
              :to="{path:'/Detail',query: /^\d+$/.test(item.kId)? {kId:item.kId } :{name:item.name,institute:item.organization}}"
            >
              <h5>{{item.name}} {{item.honor}}</h5>
            </router-link>
            <p :title="item.organization">{{item.organization}}</p>
            <p>
              {{/^[0-9]+$/.test(item.kId) ? '已认领' : '未认领'}}
              <el-checkbox
                v-if="!/^[0-9]+$/.test(item.kId)"
                @change="check(item)"
                style="margin-left:10px"
                v-model="item.checked"
              ></el-checkbox>
            </p>
          </div>
        </div>
        <p
          class="isni"
          v-if="item.isni"
        >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
        <p class="isni" v-else></p>
        <p class="subject" :title="item.subject" v-if="item.subject">学科：{{item.subject}}</p>
        <p class="subject" :title="item.subject" v-else></p>
        <ul class="keywords clearfix" v-if="item.keyword" style="background-color: #f5f5f5;">
          <li v-for="li in item.keywordList" :key="li">{{li}}</li>
        </ul>
        <ul class="keywords clearfix" v-else></ul>
      </div>
      <pagination
        :pageSizes="pageSizes"
        :total="total"
        :page.sync="pageData.PageIndex"
        :limit.sync="pageData.PageSize"
        :layout="layout"
        @pagination="getPage()"
      />
    </div>
  </div>
</template>

<script>
import { search } from '@/api/common'
import Pagination from '@/components/Pagination'

export default {
  name: 'Loading',
  components: {
    Pagination
  },
  data () {
    return {
      val: this.$route.query.name, // 传入姓名
      loading: false,
      inputOrg: '', // 检索机构
      expertsData: [], // 专家列表
      expWidth: '24%',
      screenWidth: document.documentElement.clientWidth, // 屏幕宽度
      /* 分页 */
      pageSizes: [24], // 每页数量
      total: 0,
      layout: 'sizes, prev, pager, next, jumper',
      pageData: {
        No: '',
        Name: '',
        PageSize: 24,
        PageIndex: 0
      }, // 分页信息

      tableData: [], // 合并认领列表
      isPerform: true,
      height: ''
    }
  },
  mounted () {
    var _this = this
    this.changeExpWidth(this.screenWidth)
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth // 窗口宽度
    }
    this.getData()
  },
  methods: {
    changeExpWidth (val) {
      if (val > 1480) {
        this.expWidth = '24%'
      } else if (val > 980) {
        this.expWidth = '32%'
      }
    },
    /* 分页 */
    getPage () {
      this.getData()
    },
    getData (val) {
      this.loading = true
      let index =
        this.pageData.PageIndex - 1 > 0 ? this.pageData.PageIndex - 1 : 0
      let k = val ? val + ' ' + this.val : this.val
      let data = {
        k: k,
        from: index * this.pageData.PageSize,
        size: this.pageData.PageSize
      }
      search(data)
        .then(res => {
          this.total = res.data.total
          let claimed = []
          let claim = []
          res.data.obj.forEach((item, index) => {
            if (/^[0-9]+$/.test(item.kId)) {
              claim.push(item)
            } else {
              item.checked = false
              claimed.push(item)
            }
          })
          this.expertsData = [...claimed, ...claim]
          this.expertsData.forEach((item, index) => {
            if (!item.keyword) {
              return
            }
            this.expertsData[index].keywordList = item.keyword.split(';')
          })

          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 检索机构
    search () {
      this.pageData.PageSize = 24
      this.pageData.PageIndex = 0
      this.getData(this.inputOrg)
    },
    // 选择合并专家
    check (val) {
      this.isPerform = false
      if (val.checked) {
        this.tableData.push(val)
      } else {
        this.tableData.forEach((item, index) => {
          if (item.kId === val.kId) {
            this.tableData.splice(index, 1)
          }
        })
      }
    },
    // 删除合并专家
    del (val, index) {
      this.expertsData.forEach((item, i) => {
        if (item.kId === val.kId) {
          this.expertsData[i].checked = false
        }
      })
      this.tableData.splice(index, 1)
    },
    merge () {
      localStorage.setItem('nameOrgArrays', JSON.stringify(this.tableData))
      this.$router.push({
        path: '/claim/claimResearch',
        query: { Kid: this.$route.query.Kid }
      })
    }
  },
  watch: {
    screenWidth: function (val) {
      this.changeExpWidth(val)
      this.$nextTick(function () {
        this.height = window.getComputedStyle(this.$refs.expHeader).height
      })
    },
    expertsData: {
      deep: true,
      handler (val) {
        if (!this.isPerform) {
          this.isPerform = true
          return
        }
        if (this.tableData.length) {
          this.expertsData.forEach((item, index) => {
            this.tableData.forEach((temp, i) => {
              if (temp.kId === item.kId) {
                this.expertsData[index].checked = true
                return true
              }
            })
          })
        }
        this.$nextTick(function () {
          this.height = window.getComputedStyle(this.$refs.expHeader).height
        })
      }
    }
  }
}
</script>

<style  lang="scss">
.claimSearch {
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
}
.claim {
  width: 30%;
  background: white;
  min-height: 65vh;
  .claim-top {
    display: flex;
    justify-content: center;
    .el-tag {
      font-size: 20px;
    }
  }
  .claim-table {
    margin: 20px;
    .el-form-item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .merge {
    width: 30%;
    margin-left: 35%;
  }
}
.experts {
  min-height: 65vh;
  width: 65%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .exp-top {
    width: 99%;
    margin-bottom: 20px;
    background: #fff;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    .exp-search {
      display: flex;
      align-items: center;
    }
  }
  .exp-box {
    height: 220px;
    background: white;
    border: 1px solid #ccc;
    padding: 10px;
    font-size: 0.8em;
    margin-top: 1vh;
    margin-right: 1%;
    .exp-int {
      display: flex;
      .exp-header {
        width: 80px;
        float: left;
        height: 100px;
      }
      .exp-textint {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 10px;
        p {
          margin: 5px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

        .isni {
              font-size: 12px;
          min-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 10px;
        }
        .subject {
          font-size: 12px;
          min-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
    .keywords {
      height: 44px;
      overflow: hidden;
      margin-top: 5px;
      li {
        height: 20px;
        flex-shrink: 1;
        float: left;
        border: 1px #ccc solid;
        padding: 1px 2px;
        border-radius: 4px;
        font-size: 12px;
        margin: 0 4px 2px 0;
      }
    }
  }
  .pagination-container {
    width: 99%;
    margin-top: 4vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/claim/claimSearch.vue